import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SalesContractTemplateMailMergeHdrContainerModel, SalesContractTemplateMailMergeLinkContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: 'root' })
export class SalesContractTemplateMailMergeLinkService extends BaseApiTemplateService<SalesContractTemplateMailMergeLinkContainerModel> {

    static readonly SALES_CONTRACT_TEMPLATE_MAIL_MERGE_LINK_SUBPATH = 'sales-contract-template-merge-links/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateMailMergeLinkService.SALES_CONTRACT_TEMPLATE_MAIL_MERGE_LINK_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateMailMergeLinkService.SALES_CONTRACT_TEMPLATE_MAIL_MERGE_LINK_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}